import { CloseOutlined } from "@ant-design/icons";
import { Button, Flex, Modal } from "antd";
import { useTranslation } from "react-i18next";

import ApiVersion from "@/modules/api-version";
import AppVersion from "@/modules/app-version";
import { AppCopyright } from "@/ui/app-copyright";
import { AppLogo } from "@/ui/app-logo";
import { AppSlogan } from "@/ui/app-slogan";

import { useAboutModal } from "./about-modal.hook";

import "./about-modal.style.less";

const AboutModal = () => {
  const { t } = useTranslation();
  const { isAboutOpen, closeAboutModal } = useAboutModal();

  return (
    <Modal
      open={isAboutOpen}
      onCancel={closeAboutModal}
      title={t("global:about.title")}
      footer={
        <Button icon={<CloseOutlined />} onClick={closeAboutModal}>
          {t("global:about.closeButton")}
        </Button>
      }
      classNames={{
        root: "about-modal",
        container: "about-modal--container",
        header: "about-modal--header",
        close: "about-modal--close",
        body: "about-modal--body",
        footer: "about-modal--footer",
      }}
    >
      <ApiVersion />
      <AppVersion />
      <AppLogo />
      <Flex vertical>
        <AppCopyright />
        <AppSlogan />
      </Flex>
    </Modal>
  );
};

export default AboutModal;
